/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc
 */

export const loginVerifyRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AccessRpc',
  rpcName: 'loginVerify',
  auth: 'external',
  fingerprint: '6Ij6M42W3TSiRFTwnSG29kWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};